import React, { useEffect } from 'react';
import LocationPage from '../LocationPage';

const DFWPage: React.FC = () => {
  useEffect(() => {
    document.title = 'AI & Cloud Solutions for DFW Metroplex | FretDev';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Enterprise AI and cloud engineering throughout the Dallas-Fort Worth metroplex. FretDev delivers GenAI solutions, cloud architecture, and ML services across North Texas.');
    }

    // Add location-specific schema
    const existingScript = document.querySelector('script[data-schema="dfw-location"]');
    if (existingScript) {
      existingScript.remove();
    }

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'FretDev DFW',
      description: 'AI and cloud engineering services throughout the Dallas-Fort Worth metroplex',
      areaServed: {
        '@type': 'Region',
        name: 'Dallas-Fort Worth',
        state: 'Texas',
      },
      url: 'https://fretdev.com/locations/dfw',
      sameAs: 'https://fretdev.com',
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-schema', 'dfw-location');
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.querySelector('script[data-schema="dfw-location"]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  const serviceAreas = [
    'Dallas',
    'Fort Worth',
    'Arlington',
    'Irving',
    'Plano',
    'Frisco',
    'McKinney',
    'Richardson',
    'Carrollton',
    'DFW Airport Area',
  ];

  const highlights = [
    'Metroplex Coverage: Serving all major DFW cities and suburbs with consistent quality',
    'Regional Expertise: Deep understanding of DFW business landscape and industries',
    'Scale-Ready Solutions: Architecture designed to grow with your DFW operations',
    'Distributed Support: Available across the metroplex for on-site consultations',
    'Fortune 500 Experience: Enterprise knowledge applied to DFW businesses of all sizes',
  ];

  return (
    <LocationPage
      city="the Dallas-Fort Worth Area"
      region="Dallas-Fort Worth Metroplex"
      description="FretDev serves businesses throughout the Dallas-Fort Worth metroplex with expert AI and cloud engineering services. From Arlington's corporate centers to Fort Worth's tech sector, Plano's innovation hubs to Carrollton's growing business community, we deliver enterprise-grade solutions built by engineers with decades of Fortune 500 experience."
      serviceAreas={serviceAreas}
      highlights={highlights}
    />
  );
};

export default DFWPage;
